<template>
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
  
            <el-col class="mb-2 px-0" :span="24">
              <div class="row m-0">
                <el-row :gutter="$vuetify.display.width > 1500 ? 20 : 10">
                <!-- table tabs radio group -->
                <el-col
                :span="$vuetify.display.width > 1500 ? 8 : 22"
                :class="'x-start order-1 mb-10'"
                >
                  <el-radio-group
                    v-model="chargerFilter"
                    @change="selectChargerFilter"
                    text-color="#ffff"
                    fill="#234B49"
                    :class="$vuetify.display.width < 805 ? 'width-100-p' : ''"
                  >
                    <el-radio-button
                      class="charger-group-by text-center"
                      label="1"
                      :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
                      :style="'border-radius: 7px;'"
                    >
                      {{ $vuetify.display.width < 750 ? "Sites" : "Charging Sites" }}
                    </el-radio-button>
                    <el-radio-button
                      class="port-group-by text-center end-period"
                      label="3"
                      :class="$vuetify.display.width < 750 ? 'width-40-p' : ''"
                    >
                      Customer
                    </el-radio-button>
                  </el-radio-group>
                </el-col>

              <!--  search input -->
              <el-col
                  :span="$vuetify.display.width > 1500 ? 15 : 24"
                  :class="$vuetify.display.width > 1500 ? 'x-start order-2 mb-10 pr-20' : 'x-start order-3 mb-10'"
                >
                    <el-input
                      size="large"
                      v-model="search"
                      :placeholder="selectedTableTab == 'charging_sites' ? 'Search by site name, customer, usage, abatement, lat, long ...' : 
                      selectedTableTab == 'customers' ?
                      'Search by customer, usage, abatement, number of sites ...' : '' "
                      :prefix-icon="Search"
                      class="mixedSearchBar-2"
                      id="mixedSearchBar-input-2"
                      clearable
                      @clear="handleRefresh"
                    >                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleRefresh"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>
                </el-col>
              <!--  search input -->

                <!-- download excel button -->
                <el-col
                  :class="$vuetify.display.width > 1500 ? 'd-flex justify-content-end order-3' : 'justify-content-end order-2'"
                  :span="$vuetify.display.width > 1500 ? 1 : 2"
                >
                  <el-button
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin 
                    "
                    @click="handleExportFile"
                    class="new-download-file-btn new-button-behavior"
                  >
                    <svg class="width-40 height-40">
                      <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                    </svg>
                  </el-button>
                </el-col>
                </el-row>
              </div>
            </el-col>
  
  
            <!-- tables -->
            <el-col :span="24">
              <div
                class="ma-0"
                v-loading="loading"
                :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50"
                element-loading-background="rgba(122, 122, 122, 0.8)"
              >
                  <!-- by Charging Site -->
                  <div class="custom-table-design" v-if="chargerFilter == 1">
                  <el-table
                    stripe
                    :data="site_list_display"
                    :fit="true"
                    height="300"
                    class="my-2 data-table"
                    scrollbar-always-on: false
                  >
                    <el-table-column
                      :label="'Site Name'"
                      :prop="'title'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      v-if="chargerFilter"
                    />
                    <el-table-column
                      :label="'Customer'"
                      :prop="'full_name'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      v-if="
                        $store.state.auth.user != null &&
                        $store.state.auth.user.is_admin
                      "
                    />
                    <el-table-column
                      :label="'Usage (MWh)'"
                      :prop="'usage_mwh'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      >
                        <template #default="scope">
                        {{
                            scope.row.usage_mwh == null
                            ? ""
                            : Number(scope.row.usage_mwh).toLocaleString()
                        }}
                        </template>
                    </el-table-column>
                    <el-table-column
                      :label="'Abatement (tCO2-e)'"
                      :prop="'abatement_tco2'"
                      :width="$vuetify.display.width <= 1800 ? 150 : ''"
                      sortable
                      >
                        <template #default="scope">
                        {{
                            scope.row.abatement_tco2 == null
                            ? ""
                            : Number(scope.row.abatement_tco2).toLocaleString()
                        }}
                        </template>
                    </el-table-column>
                    <el-table-column
                      :label="'Latitude'"
                      :prop="'lat'"
                      :width="$vuetify.display.width <= 1800 ? 180 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'longitude'"
                      :prop="'lng'"
                      :width="$vuetify.display.width <= 1800 ? 180 : ''"
                      sortable
                    />
                  </el-table>
                  </div>
                  <!-- customers -->
                  <div class="custom-table-design"  v-else-if="chargerFilter == 3">
                  <el-table
                    stripe
                    :data="customer_list_display"
                    :fit="true"
                    height="300"
                    class="my-2 data-table"
                    scrollbar-always-on: false
                  >
                  <el-table-column
                      :label="'Customer'"
                      :prop="'customer_name'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      v-if="
                        $store.state.auth.user != null &&
                        $store.state.auth.user.is_admin
                      "
                    />
                    <!-- <el-table-column
                      :label="'Site Name'"
                      :prop="'site_name'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      v-if="chargerFilter"
                    /> -->
                    <el-table-column
                      :label="'Usage (MWh)'"
                      :prop="'total_usage_mwh'"
                      :width="$vuetify.display.width <= 1800 ? 200 : ''"
                      sortable
                      >
                        <template #default="scope">
                        {{
                            scope.row.total_usage_mwh == null
                            ? ""
                            : Number(scope.row.total_usage_mwh).toLocaleString()
                        }}
                        </template>
                    </el-table-column>
                    <el-table-column
                      :label="'Abatement (tCO2-e)'"
                      :prop="'total_abatement_tco2'"
                      :width="$vuetify.display.width <= 1800 ? 150 : ''"
                      sortable
                      >
                        <template #default="scope">
                        {{
                            scope.row.total_abatement_tco2 == null
                            ? ""
                            : Number(scope.row.total_abatement_tco2).toLocaleString()
                        }}
                        </template>
                    </el-table-column>
                    <el-table-column
                      :label="'Number of Sites'"
                      :prop="'num_of_sites'"
                      :width="$vuetify.display.width <= 1800 ? 180 : ''"
                      sortable
                    >
                      <template #default="scope">
                        {{
                          scope.row.num_of_sites == null
                            ? ""
                            : Number(scope.row.num_of_sites).toLocaleString()
                        }}
                      </template>
                    </el-table-column>
                  </el-table>
                  </div>
            
  
                <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
                  <el-row class="row-bg" justify="space-between">
                    <el-col
                      :span="5"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <el-select
                        v-model="perPageCount"
                        placeholder="Select"
                        size="small"
                        style="width: 70px"
                      >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                      </el-select>
                    </el-col>
                    <el-col
                      :span="8"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :total="total_items"
                        v-model:page-size="page_size"
                        v-model:current-page="current_page"
                        @current-change="changePage"
                        class="my-4"
                      />
                    </el-col>
                    <el-col
                      :span="5"
                      class="d-flex justify-content-end align-items-center"
                    >
                  
                      <span class="text-white">
                        {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                          current_page * perPageCount > total_items
                            ? total_items.toLocaleString()
                            : (current_page * perPageCount).toLocaleString()
                        }}
                        of {{ total_items.toLocaleString() }}
                      </span>
                    </el-col>
                  </el-row>
                </div>
  
                <div class="custom-pagination" v-if="$vuetify.display.width < 700">
                  <el-row class="row-bg" justify="space-between">
                    <el-col
                      :span="24"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :total="total_items"
                        v-model:page-size="page_size"
                        v-model:current-page="current_page"
                        @current-change="changePage"
                        class="my-4"
                      />
                    </el-col>
                    <el-col
                      :span="10"
                      class="d-flex justify-content-end align-items-center"
                    >
                      <el-select
                        v-model="perPageCount"
                        placeholder="Select"
                        size="small"
                        style="width: 70px"
                      >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                      </el-select>
                    </el-col>
                    <el-col
                      :span="10"
                      class="d-flex justify-content-start align-items-center"
                    >
                 
                      <span class="text-white">
                        {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                          current_page * perPageCount > total_items
                            ? total_items.toLocaleString()
                            : (current_page * perPageCount).toLocaleString()
                        }}
                        of {{ total_items.toLocaleString() }}
                      </span>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </div>
    
      </el-col>
    </el-row>
  </template>
  
  <script>

  import { convertToTitleCase, createLoadingInstance } from "../common/common-tools";
  import { exportMultipleDataLists } from "../common/exportExcel";
  // EXPORT xlsx button
  // import XLSX from "xlsx";
  
  export default {
    props: {
        dataProp: {
        type: Object,
        default: null,
      },
    },
    components: {},
    data() {
      return {
 
        search: "",
        current_page: 0,
        page_size: 50,
        total_items: 100,
        loading: true,
        chargerFilter: 1,
        perPageCount: 50,
        filter: {
          customer_id: null,
          start_date: null,
          end_date: null,
          search: "",
          state: "",
        },
  
      
        selectedTableTab: '',
     
 

        request: {
          lat: 51.4700,
          lng: -0.4543,
          unit: "kms",
          radius: 10,
          start_date: "2023-01-01",
          end_date: "2024-01-01",
        },

        total_list: null,
        site_list: [],
        customer_list: [],
        site_list_searchResult: [],
        customer_list_searchResult: [],
        
        site_list_beforeSearch: [],
        customer_lsit_beforeSearch: [],

        site_list_display: [],
        customer_list_display: [],
        
      };
    },
    watch: {
      // update selected table tab when chargerFilter changed
      chargerFilter: {
        handler: function (newVal) {
          this.selectedSearchBy = 'site_name'; // reset search by when tab change
          this.setSelectTableTab(newVal);
        }
      },
  
  
      dataProp: {
        handler: function (newVal) {
           

            if(newVal == [] || newVal == null) return;
            this.site_list = newVal.site_list;
            this.site_list_beforeSearch = newVal.site_list;
            this.total_list = newVal.total_list;
            this.customer_list = newVal.customer_list;
            this.customer_lsit_beforeSearch = newVal.customer_list;

            this.selectedTableTab = 'charging_sites'; // default selected table tab

        },
        deep: true,
        immediate: true,
      },

      site_list: {
        handler: "handleRefresh",
        immediate: true,
      },

      customer_list: {
        handler: "handleRefresh",
        immediate: true,
      },

      site_list_searchResult: {
        handler: "handlePaginatedData",
        immediate: true,
      },

      customer_list_searchResult: {
        handler: "handlePaginatedData",
        immediate: true,
      },



      current_page: {
        handler: "handleRefresh",
        immediate: true,
      },

      perPageCount: {
        handler: function (newVal) {
          this.current_page = 1; // Reset to the first page
          this.page_size = parseInt(newVal);
          this.perPageCount = parseInt(newVal);
          this.handlePaginatedData(); // Update the displayed data
        },
        immediate: true,
      },

      page_size: {
        handler: "handleRefresh",
        immediate: true,
      },


    },
    mounted() {

    },
    methods: {
  
      convertLabel(str) {
        if (str == null || str == "") return "";
        return convertToTitleCase(str);
      },

      changePage(val) {
        this.current_page = val;
        this.handlePaginatedData();
      },

      handlePaginatedData(){ 
        try {
            // console.log("handlePaginatedData");

            if (this.site_list_searchResult.length > 0) {
              this.site_list_display = this.paginatedData(this.site_list_searchResult);
            } else {
              this.site_list_display = [];
            }

            if (this.customer_list_searchResult.length > 0) {
              this.customer_list_display = this.paginatedData(this.customer_list_searchResult);
            } else {
              this.customer_list_display = [];
            }

            this.loading = false; // Set loading to false after updating the data
          } catch (error) {
            console.log("Error when paginating data:", error);
        }
      },

      // pagination for table data
      paginatedData(searchResult) {

        if (searchResult == [] || searchResult == null) return [];

        let start = (this.current_page - 1) * this.page_size;
        let end = Math.min(start + this.page_size, searchResult.length); // Ensure `end` does not exceed the array length

     

        return searchResult.slice(start, end);
      },

      resetSearch() {
        if(this.selectedTableTab == 'charging_sites'){
          if(this.site_list_beforeSearch == [] || this.site_list_beforeSearch == null) return;
          this.site_list_searchResult = this.site_list_beforeSearch;
          this.total_items = this.site_list_searchResult.length;
        } else if(this.selectedTableTab == 'customers'){
          if(this.customer_lsit_beforeSearch == [] || this.customer_lsit_beforeSearch == null) return;
          this.customer_list_searchResult = this.customer_lsit_beforeSearch;
          this.total_items = this.customer_list_searchResult.length;
        } 
      },
  
      // set select table tabs labels with selected from radio box 
      setSelectTableTab(val){
        switch (val) {
          case '1':
            this.selectedTableTab = 'charging_sites'
            break;
          case '3':
            this.selectedTableTab = 'customers'
            break;
          default:
            break;
        }
      },
  
      async handleExportFile() {

        const loading = createLoadingInstance();

              try {
                  let dataToExport = {
                    total: this.total_list || [],
                    charging_sites: this.site_list || [],
                    customers: this.customer_list || [],
                  };

                  
                  // Check if any table has data
                  const hasData = Object.values(dataToExport).some((table) => table.length > 0);
                  if (!hasData) {
                    console.log("No data available for any report type.");
                    loading.close();
                    return; // Exit if no data is available
                  }

                  // Define table names for sheets
                  const tableNames = {
                    total: "Total",
                    charging_sites: "Charging Sites",
                    customers: "Customers"
                  };

                  const skipKeysList = {
                    total: [],
                    charging_sites: ['id'],
                    customers: ['customer_id'],
                    // Add skip keys for other data lists as needed...
                  };

                  try {
                      await exportMultipleDataLists({
                          title: "Abatement Within Radius",
                          tableData: dataToExport,
                          tableNames,
                          skipKeysList,
                          fileName: "AbatementWithinRadius.xlsx",
                          });
                          loading.close();
                          console.log("Excel file generated successfully!");
                  } catch (error) {
                      loading.close();
                      console.error("Error generating Excel file:", error.message);
                  }

              } catch (error) {
                  loading.close();
                  console.error("Error exporting file:", error.message);
              }
        },

  

  
      handleRefresh() {
        let search = this.search;
        if (search == "" || search == null) {
          this.resetSearch();
        } else {
          if (this.selectedTableTab == 'charging_sites') {
            const term = search.toString().toLowerCase().trim();
            let searchResult = this.site_list.filter((item) => 
              item.title?.toString().toLowerCase().includes(term) ||
              item.usage_mwh?.toString().toLowerCase().includes(term) ||
              item.abatement_tco2?.toString().toLowerCase().includes(term)||
              item.full_name?.toString().toLowerCase().includes(term)||
              item.lat?.toString().toLowerCase().includes(term)||
              item.lng?.toString().toLowerCase().includes(term)||
              item.mpg?.toString().toLowerCase().includes(term)
            );
            this.site_list_searchResult = searchResult;
            this.total_items = searchResult.length;

          } else if (this.selectedTableTab == 'customers') {
            const term = search.toString().toLowerCase().trim();
            let searchResult = this.customer_list.filter((item) => 
              item.customer_name?.toString().toLowerCase().includes(term) ||
              item.usage_mwh?.toString().toLowerCase().includes(term) ||
              item.abatement_tco2?.toString().toLowerCase().includes(term)||
              item.full_name?.toString().toLowerCase().includes(term)||
              item.num_of_sites?.toString().toLowerCase().includes(term)
            );
            this.customer_list_searchResult = searchResult;
            this.total_items = searchResult.length;
          } 
        } 

      },
      selectChargerFilter() {
        this.current_page = 1;
        this.handleRefresh();
      },
    },
  };
  </script>
  
  